import * as t from "./actionTypes";

const initialState = [];

const reminders = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case t.REMINDER_ADDED: {
			// Add only if not already present
			const exists = state.some((reminder) => reminder.id === payload.id);
			if (exists) return state;
			return [
				...state,
				payload
			];
		}
		case t.REMINDER_CHANGED: {
			const newState = state.map((reminder) =>
				reminder.id === payload.id ? { ...reminder, ...payload } : reminder
			);

			return newState;
		}
		case t.REMINDER_REMOVED: {
			const newState = state.filter((reminder) => reminder.id !== payload.id);
			return newState;
		}
		default:
			return state;
	}
};

export default reminders;
